module.exports = __webpack_public_path__ + "media/img/event/logo/rossall-be965fbaa193ad210d63287db9bb94bb.jpg";